import { DailyIntakeResult, calculateDailyIntake } from "./DailyIntake";
import { computeMealDistribution } from "./MealDistribution";
import { buildMealPlan } from "./MealPlan";
import { Recipe } from "../recipes/RecipeSchema";

export interface NutritionOutput {
  caloriesPerDay: number;
  gramsPerDay: number;
  mealsPerRecipe: Record<string, number>;
  gramsPerRecipe: Record<string, number>;
}

export function computeNutrition(
  dog: {
    weightKg: number;
    ageYears: number;
    bodyCondition: string;
    activityLevel: string;
  },
  recipes: Recipe[],
  totalMeals: number
): NutritionOutput {
  const intake = calculateDailyIntake({
    weightKg: dog.weightKg,
    ageYears: dog.ageYears,
    bodyCondition: dog.bodyCondition as any,
    activityLevel: dog.activityLevel as any,
  });

  const distribution = computeMealDistribution({
    recipes,
    totalMeals,
  });

  const mealPlan = buildMealPlan({
    gramsPerDay: intake.gramsPerDay,
    mealsPerRecipe: distribution.mealsPerRecipe,
  });

  return {
    caloriesPerDay: intake.caloriesPerDay,
    gramsPerDay: intake.gramsPerDay,
    mealsPerRecipe: distribution.mealsPerRecipe,
    gramsPerRecipe: mealPlan.gramsPerRecipe,
  };
}
